export default __webpack_public_path__ + "static/media/Asset 2@10x-8.7e965c5d.png";